"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1344],{

/***/ 77976:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ useCities; }
/* harmony export */ });
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_i18next__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(26793);


var COUNTRY_MAPPER = {
    "da-dk": "common:citiesDenmark",
    "en-uk": "common:citiesUK",
    "de-at": "common:citiesAustria",
    "de-ch": "common:citiesSwitzerland",
    "de-de": "common:cities",
    "en-de": "common:cities",
    en: "common:cities",
    de: "common:cities",
    da: "common:citiesDenmark"
};
function useCities() {
    var t = (0,react_i18next__WEBPACK_IMPORTED_MODULE_1__/* .useTranslation */ .$)().t;
    var locale = (0,next_router__WEBPACK_IMPORTED_MODULE_0__.useRouter)().locale;
    var countryCities = locale ? COUNTRY_MAPPER[locale] : [];
    var cities = t("".concat(countryCities), {
        returnObjects: true
    });
    var cityNames = Object.values(cities).sort();
    var cityKeys = Object.keys(cities);
    return {
        cities: cities,
        cityKeys: cityKeys,
        cityNames: cityNames
    };
}


/***/ }),

/***/ 81344:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ Cities; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/@heycater/design-system/dist/esm/index.js + 12 modules
var esm = __webpack_require__(95197);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js
var useTranslation = __webpack_require__(26793);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(57833);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/shared/helpers/cities.js + 1 modules
var cities = __webpack_require__(6619);
// EXTERNAL MODULE: ./src/shared/hooks/useCities.ts
var useCities = __webpack_require__(77976);
// EXTERNAL MODULE: ./src/shared/svg/cities/Berlin.tsx
var Berlin = __webpack_require__(7489);
// EXTERNAL MODULE: ./src/shared/svg/cities/Cologne.tsx
var Cologne = __webpack_require__(30947);
// EXTERNAL MODULE: ./src/shared/svg/cities/Dusseldorf.tsx
var Dusseldorf = __webpack_require__(84786);
// EXTERNAL MODULE: ./src/shared/svg/cities/FrankfurtMain.tsx
var FrankfurtMain = __webpack_require__(16707);
// EXTERNAL MODULE: ./src/shared/svg/cities/Hamburg.tsx
var Hamburg = __webpack_require__(91689);
// EXTERNAL MODULE: ./src/shared/svg/cities/Munich.tsx
var Munich = __webpack_require__(38595);
// EXTERNAL MODULE: ./src/shared/svg/cities/Other.tsx
var Other = __webpack_require__(98839);
// EXTERNAL MODULE: ./src/shared/svg/cities/Stuttgart.tsx
var Stuttgart = __webpack_require__(61737);
// EXTERNAL MODULE: ./src/static_pages/marketing_pages/helpers.ts
var helpers = __webpack_require__(10904);
;// CONCATENATED MODULE: ./src/shared/hooks/useCitySelect.ts













function useCitySelect() {
    var ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _excludeOther = ref.excludeOther, excludeOther = _excludeOther === void 0 ? false : _excludeOther;
    var ref1 = (0,useCities/* default */.Z)(), cityTranslations = ref1.cities;
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var router = (0,next_router.useRouter)();
    var selectCityOptions = [
        {
            value: "muenchen",
            label: cityTranslations["muenchen"],
            imageComponent: Munich/* default */.Z
        },
        {
            value: "berlin",
            label: cityTranslations["berlin"],
            imageComponent: Berlin/* default */.Z
        },
        {
            value: "frankfurt-am-main",
            label: cityTranslations["frankfurt-am-main"],
            imageComponent: FrankfurtMain/* default */.Z
        },
        {
            value: "hamburg",
            label: cityTranslations["hamburg"],
            imageComponent: Hamburg/* default */.Z
        },
        {
            value: "duesseldorf",
            label: cityTranslations["duesseldorf"],
            imageComponent: Dusseldorf/* default */.Z
        },
        {
            value: "koeln",
            label: cityTranslations["koeln"],
            imageComponent: Cologne/* default */.Z
        },
        {
            value: "stuttgart",
            label: cityTranslations["stuttgart"],
            imageComponent: Stuttgart/* default */.Z
        }, 
    ];
    if (!excludeOther) {
        selectCityOptions.push({
            value: "other",
            label: t("common:labels.other"),
            imageComponent: Other/* default */.Z
        });
    }
    var handleSelectCity = function(param) {
        var value = param.value;
        (0,cities/* persistCityInLocalStorage */.el)(value);
        return router.push((0,helpers/* buildFunnelUrl */.$e)({
            city: value,
            router: router
        }));
    };
    return {
        selectCityOptions: selectCityOptions,
        handleSelectCity: handleSelectCity
    };
}

;// CONCATENATED MODULE: ./src/static_pages/home/variationB/components/Cities.tsx

function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  cursor: pointer;\n  border-radius: 33px;\n  padding: ",
        ";\n  background: #f0f0f0;\n  border: 1px solid #f0f0f0;\n  &:hover {\n    background: #fff;\n    border: 1px solid #3c4340;\n  }\n  p {\n    font-size: 16px;\n    font-weight: 700;\n    letter-spacing: 0.4px;\n    line-height: 17px;\n    white-space: nowrap;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  font-size: 16px;\n  font-weight: 700;\n  line-height: 26.88px;\n  text-align: center;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  display: flex;\n  gap: ",
        "px;\n  flex-wrap: wrap;\n  margin-top: 24px;\n  justify-content: center;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}






function Cities() {
    var t = (0,useTranslation/* useTranslation */.$)("homepage").t;
    var handleSelectCity = useCitySelect().handleSelectCity;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm.Box, {
        maxWidth: 724,
        m: "auto",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                children: t("cities.title")
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Wrapper, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                        onClick: function() {
                            return handleSelectCity({
                                value: "muenchen"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            children: t("cities.munich")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                        onClick: function() {
                            return handleSelectCity({
                                value: "berlin"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            children: t("cities.berlin")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                        onClick: function() {
                            return handleSelectCity({
                                value: "frankfurt-am-main"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            children: t("cities.frankfurt")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                        onClick: function() {
                            return handleSelectCity({
                                value: "hamburg"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            children: t("cities.hamburg")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                        onClick: function() {
                            return handleSelectCity({
                                value: "duesseldorf"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            children: t("cities.duesseldorf")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                        onClick: function() {
                            return handleSelectCity({
                                value: "koeln"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            children: t("cities.cologne")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                        onClick: function() {
                            return handleSelectCity({
                                value: "stuttgart"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            children: t("cities.stuttgart")
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Pill, {
                        onClick: function() {
                            return handleSelectCity({
                                value: "other"
                            });
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(esm.Typography, {
                            children: t("cities.other")
                        })
                    })
                ]
            })
        ]
    });
}
var Pill = styled_components_browser_esm["default"].div(_templateObject(), function(param) {
    var theme = param.theme;
    return theme.spacing(1.75, 2);
});
var Title = (0,styled_components_browser_esm["default"])(esm.Typography)(_templateObject1());
var Wrapper = styled_components_browser_esm["default"].div(_templateObject2(), function(param) {
    var theme = param.theme;
    return theme.spacing(3);
});


/***/ })

}]);